import moment from 'moment';

const CANONICAL_PERIOD_REGEX = /^(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)-\d{2}$/;

const PERIOD_FIELD_NAME_REGEX = /^((start|end|from|to|tax)_?)?period(_?name)?$/i;

const PERIOD_LIKE_VALUE_REGEX
  = /^\s*(\d{1,2}-(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(-\d{2,4})?|(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)-\d{2,4})\s*$/i;

const STRING_PARSE_FORMATS: (string | typeof moment.ISO_8601)[] = [
  'MMM-YY',
  'MMM-YYYY',
  'YY-MMM',
  'DD-MMM-YY',
  'D-MMM-YY',
  'DD-MMM-YYYY',
  'D-MMM-YYYY',
  'DD-MMM',
  'D-MMM',
  'YYYY-MM-DD',
  'MM/DD/YYYY',
  moment.ISO_8601,
];

const MONTH_TOKEN_REGEX = /(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)/gi;

const titleCaseMonths = (s: string): string =>
  s.replace(MONTH_TOKEN_REGEX, m => m.charAt(0).toUpperCase() + m.slice(1).toLowerCase());

const toCanonical = (m: moment.Moment): string => m.format('MMM-YY').toUpperCase();

export const isPeriodFieldName = (field: string): boolean =>
  PERIOD_FIELD_NAME_REGEX.test(field);

export const isPeriodLikeValue = (value: unknown): boolean =>
  typeof value === 'string' && PERIOD_LIKE_VALUE_REGEX.test(value);

export const formatPeriodCell = (value: unknown): string | null => {
  if (value === null || typeof value === 'undefined' || value === '') {
    return null;
  }

  if (value instanceof Date) {
    const m = moment.utc(value);
    return m.isValid() ? toCanonical(m) : String(value);
  }

  if (typeof value === 'string') {
    if (CANONICAL_PERIOD_REGEX.test(value)) {
      return value;
    }
    const m = moment.utc(titleCaseMonths(value), STRING_PARSE_FORMATS, true);
    return m.isValid() ? toCanonical(m) : value;
  }

  return String(value);
};

export default formatPeriodCell;
